import { AllSameKeyValuesEnforcer } from '../../../globals/helpers/helpers';
import { User } from '../../../globals/store/user.data';
import { JoiEvent } from '../../../globals/store/events.data';

interface TransitionTypes {
  OnEnterEvent: string
  OnExitEvent: string
  OnEnterUser: string
  OnExitUser: string
}

export const Transitions: AllSameKeyValuesEnforcer<TransitionTypes> = {
  OnEnterEvent: 'OnEnterEvent', OnExitEvent: 'OnExitEvent', OnEnterUser: 'OnEnterUser', OnExitUser: 'OnExitUser'
}

export interface OnReset {
  onReset: (resetType: string, resetValue?: JoiEvent | User) => any
}